import script from "./SfxSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxSpinner.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSpinnerBall from 'quasar/src/components/spinner/QSpinnerBall.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerBall});
